import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type SessionService from 'bcl/services/session';

export default class LoginRoute extends Route {
  @service declare session: SessionService;

  async beforeModel() {
    await this.session.prohibitAuthentication();
  }
}
